import { useBalanceChecker } from "app/components/common";
import {
    CapType,
    getVaultBalanceAvailableToWithdraw,
    getVaultLpVirtualPrice,
    useVaultMaxAmountFromCap
} from "@bridgesplit/abf-react";
import { getUnixTs } from "@bridgesplit/utils";

import { useVaultContext } from "../VaultContext";
import { useVaultWithdrawContext } from "./VaultWithdrawContext";

export function useVaultWithdrawBalance() {
    const { userPosition, vaultExpanded } = useVaultContext();
    const { form } = useVaultWithdrawContext();
    const balances = useMaxVaultWithdraw();

    return useBalanceChecker({
        amount: form.amountPrincipal,
        customBalance: balances?.maxWithdraw,
        skip: !userPosition || !balances?.maxWithdraw,
        mint: vaultExpanded?.principalMetadata.mint
    });
}

export function useMaxVaultWithdraw() {
    const { vaultExpanded, userPosition } = useVaultContext();
    const summary = useVaultMaxAmountFromCap(vaultExpanded, CapType.Withdraw);
    const maxWithdrawCap = summary?.maxBalanceRemaining?.toNumber() ?? Number.MAX_SAFE_INTEGER;

    const now = getUnixTs();
    const vaultPrice = getVaultLpVirtualPrice(vaultExpanded, now) ?? 0;

    if (!vaultExpanded || !userPosition) return undefined;

    const globalMaxWithdraw = getVaultBalanceAvailableToWithdraw(vaultExpanded, now);
    const userLpBalance = userPosition.amountAvailable.amountLp;
    const userBalance = userLpBalance * vaultPrice;

    const maxWithdraw = Math.min(globalMaxWithdraw, userBalance, maxWithdrawCap);
    return { maxWithdraw, userBalance, globalMaxWithdraw, userLpBalance };
}
